import { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/dashboard", { replace: true }); return; }

    const poll = async () => {
      if (attempts.current >= 6) { setState("timeout"); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("success"); return; }
        if (data.status === "expired") { setState("failed"); return; }
        setTimeout(poll, 2000);
      } catch { setTimeout(poll, 2000); }
    };
    poll();
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <Card className="p-10 bg-card border-border max-w-md w-full text-center fade-up">
        {state === "checking" && (<><Loader2 className="mx-auto text-primary animate-spin mb-4" size={40} /><h1 className="text-2xl mb-2">Verifica del pagamento…</h1><p className="text-muted-foreground">Attendi qualche istante.</p></>)}
        {state === "success" && (<><CheckCircle2 className="mx-auto text-green-400 mb-4" size={48} /><h1 className="text-3xl mb-2">Pagamento riuscito!</h1><p className="text-muted-foreground mb-6">Grazie, la tua iscrizione è stata aggiornata.</p></>)}
        {(state === "failed" || state === "timeout") && (<><XCircle className="mx-auto text-destructive mb-4" size={48} /><h1 className="text-2xl mb-2">{state === "timeout" ? "Verifica in corso" : "Pagamento non completato"}</h1><p className="text-muted-foreground mb-6">{state === "timeout" ? "Controlla lo stato dalla tua area personale tra poco." : "Riprova dalla tua area personale."}</p></>)}
        {state !== "checking" && <Button data-testid="back-dashboard" onClick={() => navigate("/dashboard")} className="w-full bg-primary text-primary-foreground hover:bg-primary/90">Torna all'area personale</Button>}
      </Card>
    </div>
  );
}
